"use strict";
/// <reference types="jquery"/>

var __importDefault = undefined && undefined.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var ConventionServitude_vue_1 = __importDefault(require("./Components/ConventionServitude.vue"));
var debounce_1 = require("debounce");
$(function () {
    // Editeur de conventions
    $("convention-servitude").each(function () {
        new vue_1.default({
            components: {
                ConventionServitude: ConventionServitude_vue_1.default
            },
            el: this,
            data: {}
        });
    });
    // Admin des types de convention
    var checkSyntax = debounce_1.debounce(function (code, callback) {
        if (code == "") {
            return;
        }
        $.ajax("/Admin/TypeConventionServitude/CheckSyntax", {
            method: "post",
            data: { code: code }
        }).done(function (d) {
            callback(d);
        });
    }, 300);
    $(".convention-formula-check").each(function () {
        var $me = $(this);
        var cm = $me.data("codemirror");
        cm.on("change", function () {
            checkSyntax(cm.doc.getValue(), function (d) {
                var $msg = $me.parent().find("span.message");
                if (d.error) {
                    $msg.show().text(d.error);
                } else {
                    $msg.hide();
                }
            });
        });
    });
    $("body").on("click", ".check-unavailable-conventions", function () {
        var id = getSelectedConventions();
        if (id.length === 0) {
            return;
        }
        var $btn = $(this);
        $.ajax({
            url: "/Affaires/GetNotPrintableConventions",
            type: "get",
            data: {
                id: id,
                affaireId: $("input[name=affaireId]").val()
            },
            traditional: true,
            success: function success(data) {
                var $target = $("#unavailable-convention-docs");
                if (data.length === 0) {
                    $target.addClass("d-none");
                } else {
                    $target.removeClass("d-none").html("Les conventions suivantes n'ont pas pu \xEAtre trait\xE9es: <ul>" + data.map(function (_) {
                        return "<li>#" + _.id + " &ndash; " + (_.numero || "<em>Aucun numéro</em>") + "</li>";
                    }).join("") + "</ul>");
                }
            }
        });
    }).on("click", "#btn-edit-conventions", function () {
        var id = getSelectedConventions();
        if (id.length === 0) {
            return;
        }
        var $btn = $(this);
        $.ajax({
            url: $btn.attr("formaction"),
            type: "get",
            data: {
                id: id
            },
            traditional: true,
            success: function success(data) {
                var modal = $("#modalConventions");
                modal.find(".modal-body").html(data);
                modal.find(".modal-title").html("Modification des conventions (" + id.length + " s\xE9lectionn\xE9e(s))");
                modal.modal("show");
                modal.find("input.datepicker").initDateTimePicker();
            }
        });
    }).on("click", "input:checkbox#convention-checkbox-all", function () {
        var checkboxes = $("input:checkbox.convention-checkbox");
        var checked = $(this).is(":checked");
        checkboxes.prop("checked", checked);
        $("div.div-btn-conventions").toggleClass("d-none", !checked);
        return true;
    }).on("change", "input:checkbox.convention-checkbox", function () {
        var $checkboxConventions = $("input:checkbox.convention-checkbox"),
            divBtnConventions = $("div.div-btn-conventions"),
            nbreChecked = $checkboxConventions.filter(function (i, cb) {
            return cb.checked;
        }).length;
        // On cache ou non les boutons en conséquences
        divBtnConventions.toggleClass("d-none", nbreChecked === 0);
        if (nbreChecked > 0) {
            var allChecked = $checkboxConventions.length === nbreChecked;
            $("input:checkbox#convention-checkbox-all").prop("checked", allChecked);
        }
        return true;
    }).on("click", ".checkbox-change-champ", function () {
        var $this = $(this);
        var $divInput = $this.parents("div.row").find(".div-input");
        $divInput.toggleClass("d-none", !this.checked);
    });
    function getSelectedConventions() {
        var $cbs = $("input:checkbox.convention-checkbox:checked");
        return $.makeArray($cbs).map(function (e) {
            return parseInt(e.value);
        });
    }
});


//////////////////
// WEBPACK FOOTER
// ./_wwwsrc/js/ConventionServitude/index.ts
// module id = 639
// module chunks = 0